/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      toggleSellingPlans(variant, container)
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    // var cart = event.detail.cart;
    // if (cart) {
    //   console.log('Cart ———————————— ↓');
    //   console.log(cart);
    //   // ... update an app or a custom shipping caluclator
    // }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // STAY AI - CUSTOM JS
  const toggleSellingPlans = (variant, container) => {
    const variantName = variant.title.toLowerCase();
    const staySellingPlanEl = document.querySelector('[name="selling_plan"]')

    if (!staySellingPlanEl) return
    staySellingPlanEl.value = ''
    const matchingOption = [...staySellingPlanEl.options].find(option => variantName.includes(option.innerText.toLowerCase()) && option.innerText !== '')
    
    if (!matchingOption) return 
    staySellingPlanEl.value = matchingOption.value  
  }


  /**
   * Checks for unlinked bundle items in cart
   * @param {Array} lineItems - Cart items
   */
  function checkOrphanBundleItems(lineItems) {
    if (!lineItems || lineItems.length <= 0) return;
    let bundleItems = [...lineItems].map((item) => item?.properties?._bundle_id);
    let bundleIDs = bundleItems.filter((id) => id);
    let orphanBundleIDs = [];
    if (!bundleIDs || bundleIDs.length <= 0) return;
    bundleIDs.forEach((bundleID) => {
      let bundleMin = 0;
      let bundleMax = 0;
      let bundleCount = 0;
      const hasChildProduct = lineItems.filter(
        (item) => item.properties?._bundle_id == bundleID && !item?.properties?._bundle_parent,
      );
      const hasParentProduct = lineItems.find(
        (item) => item.properties?._bundle_id == bundleID && item?.properties?._bundle_parent === true,
      );
      if (!hasChildProduct || hasChildProduct.length <= 0 || !hasParentProduct) {
        orphanBundleIDs.push(bundleID);
        return;
      }
      bundleMin = parseInt(hasParentProduct.properties?._bundle_min) || bundleMin;
      bundleMax = parseInt(hasParentProduct.properties?._bundle_max) || bundleMax;
      bundleCount = hasChildProduct.reduce((acc, item) => acc + parseInt(item.quantity), 0) || bundleCount;
      if (bundleCount < bundleMin || bundleCount > bundleMax) {
        orphanBundleIDs.push(bundleID);
      }
    });
    if (orphanBundleIDs.length <= 0) return;
    deleteOrphanBundleProducts(lineItems, orphanBundleIDs);
  };
  /**
     * Removes all unlinked bundle products
     * @param {Array} cart - Cart line items
     * @param {Array} orphanBundleIDs - Array of unlinked products to delete
     */
  function deleteOrphanBundleProducts(cart, orphanBundleIDs) {
    const { Rebuy } = window;
    let orphanData = {
      updates: {},
    };
    orphanBundleIDs.forEach((bundleID) => {
      cart.map((item) => {
        if (!item || item?.properties?._bundle_id !== bundleID) {
          return;
        }
        orphanData["updates"][String(item.key)] = 0;
      });
    });
    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(orphanData),
    })
      .then((response) => {
        if (!Rebuy) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error removing bundle product from cart:", error);
      });
  }
  document.addEventListener("rebuy:cart.ready", (event) => {
    const lineItems = event.detail?.cart?.cart?.items;
    if (!lineItems) return;
    checkOrphanBundleItems(lineItems);
  });
  document.addEventListener("rebuy:cart.change", (event) => {
    const lineItems = event.detail?.cart?.cart?.items;
    if (!lineItems) return;
    checkOrphanBundleItems(lineItems);
  });

})();
